import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { Avatar, AVATAR_HEIGHT_24 } from '../../Avatar'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'
import { QA_NAME_DASHBOARD_BIRDVIEW_HOME_LINK } from '../DashboardBirdview.constants.qa'

import {
  checkIsBirdviewHomeContact,
  getBirdviewHomeContactHref,
  getBirdviewHomeContactTooltipKey,
  getBirdviewHomeRowLabel,
} from './BirdviewHomeRow.utils'
import { BirdviewHomeRowCopyButton } from './BirdviewHomeRowCopyButton'

import * as styles from './BirdviewHomeRow.module.css'

function BirdviewHomeRow({ item }) {
  const { t } = useTranslation()

  return (
    <div className={styles.row}>
      <Avatar
        Icon={item.Icon}
        className={styles.icon}
        size={AVATAR_HEIGHT_24}
      />
      <div className={styles.body}>
        <Text isSecondary>{getBirdviewHomeRowLabel(item, t)}</Text>
        {checkIsBirdviewHomeContact(item) ? (
          <span className={styles.contact}>
            <FloatingTooltip
              content={t(getBirdviewHomeContactTooltipKey(item))}
              placement={FLOATING_ELEMENT_PLACEMENT.top}
            >
              <Text
                Element='a'
                className={styles.link}
                href={getBirdviewHomeContactHref(item)}
                qaName={QA_NAME_DASHBOARD_BIRDVIEW_HOME_LINK}
              >
                {item.value}
              </Text>
            </FloatingTooltip>
            <BirdviewHomeRowCopyButton value={item.value} />
          </span>
        ) : (
          <Text className={styles.value}>{item.value}</Text>
        )}
      </div>
    </div>
  )
}

export default BirdviewHomeRow
